import * as types from "./types";

export const setTabState = (tabNumber) => {
  return {
    type: types.SETTABSTATE,
    payload: tabNumber,
  };
};
